var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlertWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 120,
    viewBox: "0 0 189 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.58293 38.468C3.58293 31.0457 9.59843 25.0287 17.0189 25.0287H174.668C182.088 25.0287 188.104 31.0457 188.104 38.468C188.104 45.8904 182.088 51.9074 174.668 51.9074H17.0189C9.59843 51.9074 3.58293 45.8904 3.58293 38.468Z",
    fill: "#F8F7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M163.919 78.7861H34.9336C42.3541 78.7861 48.3696 72.7691 48.3696 65.3467C48.3696 57.9244 42.3541 51.9074 34.9336 51.9074H163.919C156.499 51.9074 150.483 57.9244 150.483 65.3467C150.483 72.7691 156.499 78.7861 163.919 78.7861Z",
    fill: "#F8F7FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2464 21.4448C32.2464 15.507 37.0588 10.6934 42.9952 10.6934H152.275C158.211 10.6934 163.023 15.507 163.023 21.4448C163.023 27.3827 158.211 32.1963 152.275 32.1963H42.9952C37.0588 32.1963 32.2464 27.3827 32.2464 21.4448Z",
    fill: "#F8F7FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 93.1214C0 85.2042 6.41653 78.7861 14.3317 78.7861H173.772C181.687 78.7861 188.104 85.2042 188.104 93.1214C188.104 101.039 181.687 107.457 173.772 107.457H14.3317C6.41653 107.457 0 101.039 0 93.1214Z",
    fill: "#F8F7FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9147 110.145C17.9147 104.701 22.326 100.289 27.7677 100.289H72.5544C77.9961 100.289 82.4074 104.701 82.4074 110.145C82.4074 115.588 77.9961 120 72.5544 120H27.7677C22.326 120 17.9147 115.588 17.9147 110.145Z",
    fill: "#F8F7FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5908 0H59.6094V2.77148H60.5908V0Z",
    fill: "#C4B8FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5908 16.6284H59.6094V19.3999H60.5908V16.6284Z",
    fill: "#C4B8FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6985 1.04894L54.8486 1.54297L56.225 3.94307L57.0749 3.44904L55.6985 1.04894Z",
    fill: "#C4B8FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9602 15.4508L63.1104 15.9448L64.4867 18.3449L65.3366 17.8509L63.9602 15.4508Z",
    fill: "#C4B8FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9946 4.43L51.5039 5.28564L53.8878 6.67138L54.3785 5.81573L51.9946 4.43Z",
    fill: "#C4B8FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3061 12.7515L65.8154 13.6072L68.1993 14.9929L68.69 14.1373L66.3061 12.7515Z",
    fill: "#C4B8FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2167 9.20898H50.4639V10.197H53.2167V9.20898Z",
    fill: "#C4B8FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7304 9.20898H66.9775V10.197H69.7304V9.20898Z",
    fill: "#C4B8FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8829 12.7268L51.499 14.1125L51.9897 14.9682L54.3736 13.5825L53.8829 12.7268Z",
    fill: "#C4B8FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1846 4.41748L65.8008 5.80322L66.2915 6.65887L68.6753 5.27313L68.1846 4.41748Z",
    fill: "#C4B8FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2345 15.4487L54.8584 17.8491L55.7084 18.343L57.0845 15.9427L56.2345 15.4487Z",
    fill: "#C4B8FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4913 1.04689L63.1152 3.44727L63.9652 3.94119L65.3413 1.54081L64.4913 1.04689Z",
    fill: "#C4B8FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M22.621 86.2558H21.9466C21.9466 84.1474 20.2436 82.4329 18.1494 82.4329V81.7538C18.1528 81.7538 18.1595 81.7538 18.1629 81.7538C20.2503 81.747 21.9466 80.0359 21.9466 77.9309H22.621C22.621 80.0393 24.324 81.7538 26.4182 81.7538V82.4329C26.4148 82.4329 26.4081 82.4329 26.4047 82.4329C24.3173 82.4397 22.621 84.1508 22.621 86.2558ZM19.8524 82.0933C20.9484 82.5517 21.8285 83.4344 22.2838 84.5412C22.7391 83.4378 23.6158 82.5517 24.7152 82.0933C23.6192 81.635 22.7391 80.7523 22.2838 79.6455C21.8285 80.7523 20.9518 81.635 19.8524 82.0933Z",
    fill: "#C4B8FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M150.888 115.637C149.576 115.637 148.511 114.564 148.511 113.243C148.511 111.922 149.576 110.85 150.888 110.85C152.2 110.85 153.266 111.922 153.266 113.243C153.266 114.564 152.2 115.637 150.888 115.637ZM150.888 111.529C149.947 111.529 149.185 112.299 149.185 113.243C149.185 114.19 149.951 114.958 150.888 114.958C151.826 114.958 152.591 114.187 152.591 113.243C152.591 112.296 151.829 111.529 150.888 111.529Z",
    fill: "#C4B8FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5443 94.4357L89.1691 20.8254C91.0834 17.4403 95.9596 17.4403 97.8738 20.8254L139.499 94.4357C141.383 97.7688 138.975 101.897 135.146 101.897H51.8966C48.0675 101.897 45.6595 97.7688 47.5443 94.4357Z",
    fill: "#FFC112",
    stroke: "#6A7590",
    strokeWidth: 6,
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 88.7646,
    y: 42.7185,
    width: 10.5676,
    height: 26.4191,
    rx: 1,
    fill: "white",
    stroke: "#6A7590",
    strokeWidth: 3.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 88.7646,
    y: 74.4214,
    width: 10.5676,
    height: 12.6812,
    rx: 1,
    fill: "white",
    stroke: "#6A7590",
    strokeWidth: 3.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertWarning);
export default __webpack_public_path__ + "static/media/alert_warning.e2aed15e8d7724859b0aa473e72125b8.svg";
export { ForwardRef as ReactComponent };